module.exports = __webpack_public_path__ + "static/img/trans-sample-1.6ab4d3c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/trans-sample-1.gif
// module id = YydY
// module chunks = 0